<template>
  <span
    >Armor:
    <span v-for="(n, index) in armor" :key="index" class="icon"
      ><i class="fas fa-shield-alt"></i></span
  ></span>
</template>

<script>
export default {
  name: "ArmorItem",
  props: {
    armor: {
      type: Number,
      required: true
    }
  }
};
</script>
